// Page reducer -> responsible for managing how the state changes for pages behaves

import { FETCH_PAGES, FETCH_PAGES_FAIL } from '../actions/actions';
const INITIAL_STATE = { contentful: [] };



export default function(state = INITIAL_STATE, action) {
  let newState;

  switch(action.type) {
    case FETCH_PAGES: {
      // Clones everything in current state, merges it with payload and creates a new object and saves it -> newState
      newState = Object.assign({}, ...state, {contentful: action.payload});
      return newState;
    }
    case FETCH_PAGES_FAIL: {
      console.log("FETCH FAIL: ", action.payload);
      newState = Object.assign({}, ...state, action.payload);
      return newState;
    }
    default:
      return state;
  }

};



// WEBPACK FOOTER //
// ./client/reducers/page-reducer.js